import { defineComponent as _defineComponent } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { PaginationListItem } from 'reka-ui';
import { cn } from 'Components/primitives/utils';
import { buttonVariants } from 'Components/primitives/button';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationItem',
    props: {
        value: { type: Number, required: true },
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false },
        size: { type: null, required: false, default: 'icon' },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        isActive: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const delegatedProps = reactiveOmit(props, 'class', 'size', 'isActive');
        const __returned__ = { props, delegatedProps, get PaginationListItem() { return PaginationListItem; }, get cn() { return cn; }, get buttonVariants() { return buttonVariants; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
